import { Button, Col, Flex, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormInput } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AdminRoleModal = ({
    isOpenModal = false,
    isEdit = false,
    onClose = () => { },
    onSubmit = () => { },
    selectedRecord = null
}) => {
    const { t } = useTranslation();
    const [form] = useForm(null);

    useEffect(() => {
        if (isOpenModal) {
            if (isEdit && selectedRecord) {
                form.setFieldsValue({ ...selectedRecord });
            } else {
                form.resetFields();
            }
        }
    }, [isOpenModal, isEdit, selectedRecord, form]);

    const handleClose = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            open={isOpenModal}
            title={isEdit ? t("common.edit") : t("common.create")}
            closable={false}
            maskClosable={false}
            footer={false}
        >
            <FormAntd
                form={form}
                initialValues={isEdit ? { ...selectedRecord } : null}
                onFinish={onSubmit}
            >
                <FormItem shouldUpdate={(prev, curv) => {
                    return false
                }}>
                    {({ getFieldValue, setFieldValue, resetFields }) => {
                        return (
                            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                                <Flex vertical gap={8}>
                                    <FormInput
                                        name="roleName"
                                        label={t("usermanagment.role_th")}
                                        placeholder={t("common.please_fill")}
                                        required
                                        size="large"
                                    />
                                    <FormInput
                                        name="roleNameEn"
                                        label={t("usermanagment.role_en")}
                                        placeholder={t("common.please_fill")}
                                        required
                                        size="large"
                                    />
                                    <FormInput
                                        name="description"
                                        label={t("master.label.description_th")}
                                        placeholder={t("common.please_fill")}
                                        size="large"
                                        type="textarea"
                                        rows={4}
                                    />
                                    <FormInput
                                        name="descriptionEn"
                                        label={t("master.label.description_en")}
                                        placeholder={t("common.please_fill")}
                                        size="large"
                                        type="textarea"
                                        rows={4}
                                    />
                                </Flex>

                                <Flex justify="end" gap={8}>
                                    <Button
                                        type="default"
                                        size="large"
                                        style={{ borderRadius: "8px" }}
                                        onClick={() => handleClose()}                                    >
                                        {t("common.cancel")}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        size="large"
                                        style={{ borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                                    >
                                        {t("common.confirm")}
                                    </Button>
                                </Flex>
                            </Space>
                        )
                    }}
                </FormItem>
            </FormAntd>
        </Modal>
    )
}

export default AdminRoleModal;